// extracted by mini-css-extract-plugin
module.exports = {"root":"hover-overlay_root__xI98k","root_content":"hover-overlay_root_content__3xfWT"};